import {
  Avatar,
  Button,
  CloseButton,
  CrudMode,
  DELETE_WARNING,
  DropDownMenu,
  ListContext,
  ListContextValue,
  MenuItemType,
  Stack,
  Typography,
  UpdateButton,
  ValidationErrors,
  newToast,
} from "@compass/core";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SchoolIcon from "@mui/icons-material/School";
import { SubmitButton } from "components";
import { Permission, PermissionAction, Student, StudentViewResource } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";
import { StudentTab } from "./StudentPage";
import { studentServicePageRoute } from "pages/students/student-services/StudentServicePage/StudentServicePage";

export const StudentPageHeader = (props: {
  rootPermission: Permission;
  crudMode: CrudMode;
  fetch: (id: number) => void;
  reroute: (id: number, crudMode: CrudMode) => void;
  setCurrentTab: (tab: StudentTab) => void;
  student: Student;
  viewResource: StudentViewResource;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const id = props.student.id;

  const save = (student: Student) => {
    props.setValidationErrors({});

    if (id > 0) {
      ApiService.students
        .saveUpdate(student)
        .then(() => {
          props.reroute(id, "view");
          props.fetch(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    } else {
      ApiService.students
        .saveCreate(student)
        .then((response) => {
          const id = response;
          props.reroute(id, "view");
          props.fetch(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    }
  };

  const postDelete = (id: number) => {
    if (window.confirm(DELETE_WARNING)) {
      ApiService.students.delete(id).then(() => {
        navigate("../");
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      });
    }
  };

  const menuItems: MenuItemType[] = [];

  if (isAuthorized(props.rootPermission, PermissionAction.Delete))
    menuItems.push({
      label: <Typography color="error">Delete</Typography>,
      action: () => postDelete(id),
    });

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        <Avatar string={`${props.student.firstName} ${props.student.lastName}`} size="large" />

        <Stack>
          <Stack direction="row" spacing="sm" alignItems="center">
            <Typography variant="h6">
              {props.student.firstName} {props.student.lastName}
            </Typography>
            <Typography fontWeight="light">{props.student.customId1}</Typography>
          </Stack>

          <Stack direction="row" spacing="md">
            <Stack direction="row" spacing="sm">
              <AccountBalanceIcon fontSize="small" opacity={0.3} />
              <Typography variant="caption">
                {props.viewResource.currentSchool ? props.viewResource.currentSchool : "No current school"}
              </Typography>
            </Stack>

            <Stack direction="row" spacing="sm">
              <SchoolIcon fontSize="small" opacity={0.3} />
              <Typography variant="caption">
                {props.viewResource.currentGradeLevel ? props.viewResource.currentGradeLevel : "No current grade level"}
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        {menuItems.length > 0 && <DropDownMenu menuItems={menuItems} />}
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />

        {props.crudMode === "view" && isAuthorized(Permission.StudentService, PermissionAction.Create) && (
          <Button
            onClick={() => {
              props.setCurrentTab("Services");
              navigate({
                pathname: studentServicePageRoute.getPath({
                  id: 0,
                  crudMode: "edit",
                  screenType: "dialog",
                }),
                search: studentServicePageRoute.getOptionalParams?.({
                  studentId: id,
                  hideStudent: true,
                }),
              });
            }}
            variant="outlined"
          >
            + Service
          </Button>
        )}

        {/* {props.crudMode === "view" && isAuthorized(props.rootPermission, PermissionAction.Update) && (
          <UpdateButton onClick={() => props.reroute(id, "edit")} />
        )} */}

        {/* {props.crudMode === "edit" && (
          <SubmitButton onClick={() => save(props.student)} disabled={!props.unsavedChanges} />
        )} */}
      </Stack>
    </Stack>
  );
};
